import reducer from './reducers';
import * as featureActions from './actions';

export { featureActions };
export default reducer;
